var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 677.72 223.33",
    style: {
      enableBackground: "new 0 0 677.72 223.33"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#182742;}\n\t.st1{fill:#00D4C1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000000209962049627088370000014353278175960938904_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.38,0.03H0v223.3h84.38c70.19,0,112.75-43.65,112.75-111.66S154.57,0.03,84.38,0.03z M81.48,172.8h-24V50.2 h24c37.08,0,57.81,23.64,57.81,61.47c0,37.46-20.73,61.1-57.81,61.1L81.48,172.8z M398.79,76.03c0-48.74-33.12-76-81.12-76H217.26 v223.3h57.85V149.5h20.37L342,223.33h64.74l-52.39-80C381.67,133.13,398.79,109.85,398.79,76.03z M311.48,102.95h-36.37V49.1h36.37 c20.73,0,30.17,10.55,30.17,26.92S332.21,102.94,311.48,102.95L311.48,102.95z M560.13,0.03H504l58.8,222.9h56.09L560.13,0.03z  M404.46,0.03l58.79,222.9h56.09L460.55,0.03H404.46z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "677.72,0 610.46,0 644.09,127.5  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrw);
export default __webpack_public_path__ + "static/media/DRW.fff2a9fb4ed398003cdf0e8c73c9d852.svg";
export { ForwardRef as ReactComponent };